import {
  printModalTableContentA4,
  saveModalTableContentAsPdf,
} from './modalDocumentExport';

export async function saveDocumentExportPreviewAsPdfAndClose(params: {
  root: HTMLElement;
  fileName: string;
  captureCss: string;
}): Promise<void> {
  await saveModalTableContentAsPdf({
    root: params.root,
    fileName: params.fileName,
    captureCss: params.captureCss,
    useLiveComputedStyles: true,
  });
  window.setTimeout(() => {
    window.close();
  }, 300);
}

export async function printDocumentExportPreviewFromRoot(params: {
  root: HTMLElement;
  title: string;
  captureCss: string;
}): Promise<void> {
  await printModalTableContentA4({
    root: params.root,
    title: params.title,
    captureCss: params.captureCss,
    useLiveComputedStyles: true,
  });
}
